import React from 'react'
import { observer } from 'mobx-react-lite'
import Input from '../../../../../../../../components/FormComponents/Input'

export default observer(function InstaPostInsightForm({ formProps, linkedin = false }) {
  const { handleBlur, handleChange, values, touched, errors } = formProps

  return (
    <div className='flex flex-col gap-2'>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.reach && errors.reach}
            noLabelPadding
            label="Reach"
            placeholder="Reach"
            name='reach'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.reach || ''}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.impressions && errors.impressions}
            noLabelPadding
            label="Impressions"
            placeholder="Impressions"
            name='impressions'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.impressions || ''}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.likes && errors.likes}
            noLabelPadding
            label={linkedin ? 'Reactions' : 'Likes'}
            placeholder={linkedin ? 'Reactions' : 'Likes'}
            name='likes'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.likes || ''}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.comments && errors.comments}
            noLabelPadding
            label="Comments"
            placeholder="Comments"
            name='comments'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.comments || ''}
          />
        </div>
        {!linkedin && (
          <div>
            <Input
              overrideClassName="pl-4 h-8"
              topMargin={false}
              error={touched.saves && errors.saves}
              noLabelPadding
              label="Saves"
              placeholder="Saves"
              name='saves'
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.saves || ''}
            />
          </div>
        )}
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.shares && errors.shares}
            noLabelPadding
            label="Shares"
            placeholder="Shares"
            name='shares'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.shares || ''}
          />
        </div>
        <div>
          <Input
            overrideClassName="pl-4 h-8"
            topMargin={false}
            error={touched.reposts && errors.reposts}
            noLabelPadding
            label="Reposts"
            placeholder="Reposts"
            name='reposts'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.reposts || ''}
          />
        </div>
      </div>
    </div>
  )
})
